import {
    AccountMagicLink, ACHBankInfo, ClientSecret,
    CredentialsObj,
    PartnerAccountsObject,
    PartnerBankInfo,
    PartnerBillingDetailsObject,
    PartnerCreditCardDetailsObject,
    PartnerDetailsObj,
    PartnerInvoicesObject,
    PartnerThirdPartyBillingDetailsObject, PayoutBankInfo,
    SelectedPageComponent,
    PaypalApprovalLink,
    PaypalInfo,
    PaypalIdentity,
    LastMonthBilling
} from "../Model/businessObjects";
import {DASHBOARD_COMPONENT} from "../Components/Dashboard/dashboardWrapper";

export const constructCredentialsObj = (email, pass) => {
    return new CredentialsObj(email, pass);
}

export const constructSelectedComponent = (component = DASHBOARD_COMPONENT) => {
    return new SelectedPageComponent(component);
}

export const constructPartnerDetails = (partnerId, partnerType, address, billingAddress, billingDiscountAmount, companyName, contactPerson, contactPersonTitle, email, phoneNo, partnerCode) => {
    return new PartnerDetailsObj(partnerId, partnerType, address, billingAddress, billingDiscountAmount, companyName, contactPerson, contactPersonTitle, email, phoneNo, partnerCode);
}

export const constructPartnerAccounts = (accountsArray) => {
    return new PartnerAccountsObject(accountsArray);
}

export const constructPartnerBillingDetails = (billingArray) => {
    return new PartnerBillingDetailsObject(billingArray);
}

export const constructPartnerInvoice = (invoicesArr) => {
    return new PartnerInvoicesObject(invoicesArr);
}

export const constructPartnerCardDetails = (last4Digits, expireMonth, expireYear) => {
    return new PartnerCreditCardDetailsObject(last4Digits, expireMonth, expireYear);
}

export const constructPartnerBankInfo = (name, routing, acc, firstName, lastName, email) => {
    return new PartnerBankInfo(name, routing, acc, firstName, lastName, email);
}

export const constructThirdPartyBillingDetails = (billingArr) => {
    return new PartnerThirdPartyBillingDetailsObject(billingArr);
}

export const constructMagicLink = (link) => {
    return new AccountMagicLink(link);
}

export const constructACHBankInfo = (bankName, last4Digits, routingNo, email, customerId) => {
    return new ACHBankInfo(bankName, last4Digits, routingNo, email, customerId);
}

export const constructClientSecret = (secret) => {
    return new ClientSecret(secret);
}

export const constructPayoutBankInfo = (stripeAccountId, actorId, actorType, connectStatus, stripeEmail, accountNumber, routingNumber, accountHolder, ipAddress) => {
    return new PayoutBankInfo(stripeAccountId, actorId, actorType, connectStatus, stripeEmail, accountNumber, routingNumber, accountHolder, ipAddress);
}


export const contructPaypalApprovalLink = (link) => {
    return new PaypalApprovalLink(link);
}

export const constructPaypalInfo = (accId, email, customerId, confirmedAt) => {
    return new PaypalInfo(accId, email, customerId, confirmedAt);
}

export const constructPaypalIdentity = (email, accId, name, confirmedAt, verified) => {
    return new PaypalIdentity(email, accId, name, confirmedAt, verified)
}

export const constructLastMonthBilling = (billingId, isPaid) => {
    return new LastMonthBilling(billingId, isPaid);
}